/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';

@Component({
  selector: 'well-wizard-tab',
  templateUrl: './wizard-tab.component.html',
  styleUrls: ['./wizard-tab.component.scss']
})
export class WizardTabComponent {

  @Input() label: string | undefined = undefined;

  @ViewChild(TemplateRef, {static: true}) template: TemplateRef<any> | undefined = undefined;
}
